import componentList from '@/custom-component/component-list';
import { deepCopy, uuid } from '@/utils/utils';

const TYPE_MAP = {
  text: { component: 'v-text' },
  line: { component: 'LineComp' },
  button_square: { component: 'v-button', type: 'square' },
  button_round: { component: 'v-button', type: 'round' },
  button_round_angle: { component: 'v-button', type: 'round-angle' },
  picture: { component: 'Picture' },
  stream_media: { component: 'StreamMedia' },
  video: { component: 'Video' },
  music: { component: 'Music' },
  weather: { component: 'Weather' },
  carousel: { component: 'Carousel' },
  date: { component: 'Date' },
  environment: { component: 'Environment' },
  document: { component: 'Document' },
  webpage: { component: 'Webpage' },
  slider: { component: 'Slider' },
  status_light: { component: 'StatusLight' },
  child_page: { component: 'ChildPage' },
  visualization: { component: 'Visualization' },
};

function findTemplate(component, type) {
  return componentList.find((item) => {
    if (item.component !== component) return false;
    if (type && item.type !== type) return false;
    if (!type && item.type) return false;
    return true;
  });
}

export function resolveComponentType(typeKey) {
  return TYPE_MAP[typeKey] || null;
}

export function createComponent(typeKey, options = {}) {
  const spec = TYPE_MAP[typeKey];
  if (!spec) {
    throw new Error(`不支持的组件类型: ${typeKey}`);
  }
  const template = findTemplate(spec.component, spec.type);
  if (!template) {
    throw new Error(`未找到组件模板: ${typeKey}`);
  }
  const component = deepCopy(template);
  component.id = uuid();
  component.groupStyle = {};
  if (component.component === 'v-button') {
    component.style.alias = `${component.style.alias || component.label}${uuid()}`;
  }
  const { x = 100, y = 100, text, alias } = options;
  component.style.left = x;
  component.style.top = y;
  if (text !== undefined && component.propValue !== undefined && typeof component.propValue === 'string') {
    component.propValue = text;
  }
  if (alias && component.style) {
    component.style.alias = alias;
  }
  return component;
}

export function getNextZIndex(componentData) {
  if (!Array.isArray(componentData) || !componentData.length) return 2;
  return componentData.length + 1;
}

export function clampPosition(component, canvasStyle) {
  if (!canvasStyle) return component;
  const { width: cw = 1200, height: ch = 740 } = canvasStyle;
  const s = component.style || {};
  if (s.top + s.height > ch) s.top = Math.max(0, ch - s.height);
  if (s.left + s.width > cw) s.left = Math.max(0, cw - s.width);
  return component;
}

export { TYPE_MAP, componentList as baseComponentList };
